import React from 'react';
import './RewardListEditor.css';
import {INVENTORY_ITEMS} from '../../../constants/inventoryItems';
import {MINUS_SIGN} from '../../../constants/text';
import {getPartnerRewardDisplayProps} from '../../../utils/partner/getPartnerRewardDisplayProps';

// Типы наград — любой предмет инвентаря, кроме «всех фракций» (те же, что у
// партнерских наград)
export const REWARD_TYPE_OPTIONS = [
  {value: INVENTORY_ITEMS.NUMENS, label: 'Нумены'},
  {value: INVENTORY_ITEMS.CRYSTALS, label: 'Кристаллы'},
  {value: INVENTORY_ITEMS.PREMIUM, label: 'Премиум (дни)'},
  {value: INVENTORY_ITEMS.CHEST, label: 'Сундук'},
  {value: INVENTORY_ITEMS.FACTION, label: 'Фракция'},
  {value: INVENTORY_ITEMS.FACTION_SKIN, label: 'Образ фракции'},
  {value: INVENTORY_ITEMS.FACTION_UNIT_SKIN, label: 'Образ отрядов фракции'},
];

export const NUMERIC_REWARD_TYPES = [
  INVENTORY_ITEMS.NUMENS,
  INVENTORY_ITEMS.CRYSTALS,
  INVENTORY_ITEMS.PREMIUM,
];

const REWARD_VALUE_PLACEHOLDERS = {
  [INVENTORY_ITEMS.NUMENS]: 'Количество нуменов',
  [INVENTORY_ITEMS.CRYSTALS]: 'Количество кристаллов',
  [INVENTORY_ITEMS.PREMIUM]: 'Количество дней',
  [INVENTORY_ITEMS.CHEST]: 'id сундука',
  [INVENTORY_ITEMS.FACTION]: 'id фракции',
  [INVENTORY_ITEMS.FACTION_SKIN]: 'id скина',
  [INVENTORY_ITEMS.FACTION_UNIT_SKIN]: 'id фракции',
};

/**
 * Редактируемый список наград {itemType, value} — тот же UX, что у наград
 * рефералам на странице партнера: селект типа + поле значения, «+» у
 * последней строки, «−» у остальных, под строкой превью предмета из
 * конфигурации (иконка + русское название; неизвестный id подсвечивается).
 * readOnly — только превью (без полей ввода).
 */
function RewardListEditor({rewards, onChange, readOnly = false, disabled = false}) {
  const updateReward = (index, patch) => {
    const next = [...rewards];
    next[index] = {...next[index], ...patch};
    onChange(next);
  };

  return (
    <>
      {rewards.map((reward, index) => {
        const isLast = index === rewards.length - 1;
        const isNumeric = NUMERIC_REWARD_TYPES.includes(reward.itemType);
        const hasValue = Boolean(String(reward.value).trim());
        const display = hasValue ? getPartnerRewardDisplayProps(reward) : null;
        return (
          <div key={index} className="reward-list-editor-item">
            {!readOnly && (
              <div className="reward-list-editor-row">
                <select
                  className="reward-list-editor-input reward-list-editor-select"
                  value={reward.itemType}
                  onChange={(e) => updateReward(index, {itemType: e.target.value, value: ''})}
                  disabled={disabled}
                >
                  {REWARD_TYPE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
                <input
                  className="reward-list-editor-input"
                  type={isNumeric ? 'number' : 'text'}
                  min={isNumeric ? '1' : undefined}
                  value={reward.value}
                  onChange={(e) => updateReward(index, {value: e.target.value})}
                  placeholder={REWARD_VALUE_PLACEHOLDERS[reward.itemType] || 'Значение'}
                  disabled={disabled}
                />
                {isLast ? (
                  <button
                    type="button"
                    className="reward-list-editor-row-button"
                    onClick={() => onChange([...rewards, {itemType: INVENTORY_ITEMS.NUMENS, value: ''}])}
                    title="Добавить награду"
                  >
                    +
                  </button>
                ) : (
                  <button
                    type="button"
                    className="reward-list-editor-row-button"
                    onClick={() => onChange(rewards.filter((_, i) => i !== index))}
                    title="Удалить награду"
                  >
                    {MINUS_SIGN}
                  </button>
                )}
              </div>
            )}
            {display && (
              <div
                className={`reward-list-editor-preview partner-form-reward-preview_type-${display.itemType} ${display.isKnown ? '' : 'reward-list-editor-preview_unknown'}`}
              >
                {display.iconSrc && (
                  <img className="reward-list-editor-preview-icon" src={display.iconSrc} alt=""/>
                )}
                <span className={`reward-list-editor-preview-title ${display.colorClass}`}>
                  {display.title}
                  {display.amountLabel ? `: ${display.amountLabel}` : ''}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}

export default RewardListEditor;
